import { render, staticRenderFns } from "./HiringPlanNotificationsTab.vue?vue&type=template&id=f790286c&scoped=true"
import script from "./HiringPlanNotificationsTab.vue?vue&type=script&lang=js"
export * from "./HiringPlanNotificationsTab.vue?vue&type=script&lang=js"
import style0 from "./HiringPlanNotificationsTab.vue?vue&type=style&index=0&id=f790286c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f790286c",
  null
  
)

export default component.exports